import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Inter";
        src: url("/fonts/Inter-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Roboto";
        src: url("/fonts/Roboto-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Inter';
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #EFEFEF;
        overflow-x: hidden;
    }

    a:hover {
        color: #5271ff;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: #fdfdfd;
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: #fff;
            box-shadow: #5271ff 0px 0px 2px 0px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Roboto';
        color: #545454;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #545454;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #5271ff;

        :hover {
            color: #5271ff;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
